import { render, staticRenderFns } from "./PesquisaAlimentacaoDiaria.vue?vue&type=template&id=504fd70f&scoped=true"
import script from "./PesquisaAlimentacaoDiaria.vue?vue&type=script&lang=js"
export * from "./PesquisaAlimentacaoDiaria.vue?vue&type=script&lang=js"
import style0 from "./PesquisaAlimentacaoDiaria.vue?vue&type=style&index=0&id=504fd70f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504fd70f",
  null
  
)

export default component.exports